export const aboutMeDE = {
  title: "Senior Softwareentwickler",
  cover: [
    "Hallo! Ich bin Senior Softwareentwickler mit 9+ Jahren Erfahrung, hauptsächlich mit Fokus auf Webentwicklung und der Leitung technischer Teams.",
    "Mein Ziel ist es, die User Experience zu verbessern und sinnvollen Mehrwert zu schaffen, indem ich in engem Kontakt mit Endnutzer:innen bleibe und gleichzeitig sauberen, skalierbaren Code liefere. Ich baue starke, authentische Beziehungen zu meinem Team auf und unterstütze dessen Wachstum und Weiterentwicklung. Ich bin Autodidakt, offen gegenüber Tools und Technologie-Stacks und stets bereit für neue Herausforderungen.",
  ],
  info: [
    "Ausbildung: Computertechnik (Associate)",
    "Location: Berlin, Deutschland",
    "Familienstand: Ledig",
    "Geburtsdatum: 22 Feb 1996",
  ],
};
